import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import styles from "./filter.module.css";
import { industriesData } from "./industriesData";
import { MdCancel } from "react-icons/md";
import useStore from "../../../Store";
import {
    searchCompaniesById,
    searchCompanies,
} from "../../../Services/APIrequests";
import { BusinessesforSalecardscreate } from "../../../Services/APIrequests";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import S3FileUpload from "react-s3";
import { config } from "./config";
import defaultIMG from "../../../Assets/defaultimg.png";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

window.Buffer = window.Buffer || require("buffer").Buffer;

Modal.setAppElement("#root");

const CreateBusinessModal = ({
    showCreateForm,
    setShowCreateForm,
    handleInputChange,
    addNewBusiness,
}) => {
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [selectedItem, setSelectedItem] = useState("");
    const [companyData, setCompanyData] = useState(null);
    const [businesses, setBusinesses] = useState([]);

    // New states for company search
    const [companies, setCompanies] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showCompanies, setShowCompanies] = useState(false);
    const [apiStatus, setApiStatus] = useState(null);
    const [companyName, setCompanyName] = useState();
    const documentInputRef = useRef();
    const imageInputRef = useRef();
    const searchInputRef = useRef();
    const { Theme } = useStore();
    const [errors, setErrors] = useState({});
    const [businessImages, setBusinessImages] = useState([]);
    const imagesInputRef = useRef();

    const [newBusiness, setNewBusiness] = useState({
        CIN: "",
        operation_type: "",
        with_website: "",
        business_name: "",
        roc: "",
        authorised_capital: "",
        paid_up_capital: "",
        turn_over: "",
        pat: "",
        location: "",
        vintage_year: "",
        date_of_incorporation: "",
        document: null,
        business_image: null,
        about_company: "",
        email: "",
        industry: "",
        legal_entity: "",
        sale_price: "",
        city: "",
        state: "",
        Registrant: "",
        linkedin: "",
        google: "",
    });

    const validateFields = () => {
        const newErrors = {};

        const fieldLabels = {
            CIN: "CIN",
            business_name: "Business Name",
            sale_price: "Sale Price",
            email: "Email",
            city: "City",
            state: "State",
            about_company: "About Company",
            vintage_year: "Vintage Year",
            operation_type: "Operation Type",
            Registrant: "Registrant",
            legal_entity: "Legal Entity",
        };

        const requiredFields = Object.keys(fieldLabels);

        requiredFields.forEach((field) => {
            const value = newBusiness[field];
            if (
                value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "") ||
                (Array.isArray(value) && value.length === 0)
            ) {
                newErrors[field] = fieldLabels[field];
            }
        });

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            const missingFieldsList = Object.values(newErrors)
                .map((label) => `<li style="font-size:14px;">• ${label}</li>`)
                .join("");

            warningSwal({
                title: `<span style="font-size:16px; font-weight:600; margin:0 ;">Please fill in the following required fields:</span>`,
                html: `<ul style="text-align:left; list-style-type:none; margin-top:10px;">${missingFieldsList}</ul>`,
                icon: "warning",
            });

            const firstMissingField = Object.keys(newErrors)[0];
            const fieldElement = document.querySelector(
                `[name="${firstMissingField}"]`
            );
            if (fieldElement) {
                fieldElement.focus();
            }

            return false;
        }

        return true;
    };

    // Company search function
    const searchCompanyHandler = async (searchValue = searchTerm) => {
        if (!searchValue.trim() || searchValue.length < 2) {
            setCompanies([]);
            setShowCompanies(false);
            return;
        }

        setLoading(true);
        setError("");

        try {
            const queryKey = /^[A-Z]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/.test(
                searchValue.toUpperCase()
            )
                ? "cin"
                : "name";

            const response = await searchCompanies({ [queryKey]: searchValue });

            if (response.status === 200) {
                setApiStatus(response.data.Status);

                if (response.data.Status === 1) {
                    setCompanies(response.data.companies || []);
                    setShowCompanies(true);
                } else if (response.data.Status === 2) {
                    const filteredCompanies =
                        response.data.companies?.map((item) => ({
                            cin: item.companyID,
                            companyName: item.companyName,
                        })) || [];
                    setCompanies(filteredCompanies);
                    setShowCompanies(true);
                } else {
                    setCompanies([]);
                    setShowCompanies(false);
                }
            } else {
                setCompanies([]);
                setError("No companies found");
                setShowCompanies(false);
            }
        } catch (err) {
            setError("Companies Not Found");
            console.error("Error searching companies:", err);
            setShowCompanies(false);
        } finally {
            setLoading(false);
        }
    };

    // Search by company name only
    // Handle company selection from dropdown
    const handleCompanySelect = async (selectedCompany) => {
        try {
            // CIN & Company Name
            const cinValue = selectedCompany.CIN || selectedCompany.cin || "";
            const companyName =
                selectedCompany.CompanyName ||
                selectedCompany.companyName ||
                "";

            // setNewBusiness((prev) => ({
            //   ...prev,
            //   CIN: cinValue,
            //   business_name: companyName,
            // }));

            setCompanyName(companyName);
            setShowCompanies(false);

            // SuccessSwal("Fetching full company details...");

            // Fetch full details
            const response = await searchCompaniesById(
                cinValue,
                "your-auth-token"
            );
            console.log(response);
            if (response?.data?.companyWithTopData) {
                const company = response.data.companyWithTopData;

                // Email handling (string or array)
                const emailValue = Array.isArray(company.EmailIds)
                    ? company.EmailIds[0] || ""
                    : company.EmailIds || "";
                console.log(company);
                setNewBusiness((prev) => ({
                    ...prev,
                    CIN: company.CIN || prev.CIN,
                    google: company.WebsiteURL || "",
                    business_name: company.CompanyName || prev.business_name,
                    roc: company.Registrar_Of_Companies || "",
                    authorised_capital: company.Authorized_Capital || "",
                    paid_up_capital: company.PaidUp_Capital || "",
                    turn_over: company.netRevenue || "",
                    pat: company.profit_discontinuingOperations_afterTax || "",
                    location:
                        company.RegisteredOfficeAddress ||
                        company.Company_Address ||
                        "",
                    date_of_incorporation: company.DateOfRegistration || "",
                    vintage_year: company.vintageYear || "",
                    // ✅ Prefill AboutCompany rich text
                    about_company: company.AboutCompany || "",
                    email: emailValue,
                    state: company.state || "",
                }));

                // SuccessSwal("Company details populated successfully!");
            } else {
                warningSwal("No detailed data found for this company.");
            }
        } catch (error) {
            console.error("Error fetching company details:", error);
            warningSwal("Error fetching company details, please try again.");
        }
    };

    console.log(newBusiness);

    // Handle company selection from dropdown

    // Auto-search when typing (debounced)
    useEffect(() => {
        if (searchTerm.length >= 2) {
            const timeoutId = setTimeout(() => {
                searchCompanyHandler(searchTerm);
            }, 300);

            return () => clearTimeout(timeoutId);
        } else {
            setCompanies([]);
            setShowCompanies(false);
        }
    }, [searchTerm]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                searchInputRef.current &&
                !searchInputRef.current.contains(event.target)
            ) {
                setShowCompanies(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Keep your original useEffect for CIN manual input
    //  useEffect(() => {
    //   if (newBusiness?.CIN && newBusiness.CIN.length > 15 && !searchTerm) {
    //     searchCompaniesById(newBusiness.CIN, "your-auth-token")
    //       .then((response) => {
    //         if (response?.data?.companyWithTopData) {
    //           const company = response.data.companyWithTopData;

    //           const emailValue = Array.isArray(company.EmailIds)
    //             ? company.EmailIds[0] || ""
    //             : company.EmailIds || "";
    // console.log("Company API full response:", company);

    //           setNewBusiness((prev) => ({
    //             ...prev,
    //             CIN: company.CIN || prev.CIN,
    //             business_name: company.CompanyName || "",
    //             roc: company.Registrar_Of_Companies || "",
    //             authorised_capital: company.Authorized_Capital || "",
    //             paid_up_capital: company.PaidUp_Capital || "",
    //             turn_over: company.netRevenue || "",
    //             pat: company.profit_discontinuingOperations_afterTax || "",
    //             location: company.RegisteredOfficeAddress || company.Company_Address || "",
    //             date_of_incorporation: company.DateOfRegistration || "",
    //             vintage_year: company.vintageYear || "",
    //             // ✅ Prefill AboutCompany rich text
    //             about_company: company.AboutCompany || "",
    //             email: emailValue,
    //             state: company.state || "",
    //           }));
    //         } else {
    //           warningSwal("Company data not found for the provided CIN.");
    //         }
    //       })
    //       .catch((error) => {
    //         console.error("Error fetching company data:", error);
    //         warningSwal("Error fetching company data, please try again.");
    //       });
    //   }
    // }, [newBusiness.CIN, searchTerm]);

    const handleCreateBusiness = async () => {
        // const isValid = validateFields();

        // if (!isValid) {
        //     return;
        // }

        const industry = [
            selectedCategory,
            selectedSubcategory || "",
            selectedItem || "",
        ].filter((item) => item);

        let businessData = {
            ...newBusiness,
            industry: industry,
            operation_type: newBusiness.operation_type,
            with_website: newBusiness.with_website,
            Registrant: newBusiness.Registrant,
            state: newBusiness.state,
            city: newBusiness.city,
        };
        if (businessImages && businessImages.length > 0) {
            businessData = {
                ...businessData,
                businessImages: businessImages,
            };
        }
        if (newBusiness.vintage_year) {
            businessData = {
                ...businessData,
                vintage_year: parseInt(newBusiness.vintage_year, 10),
            };
        }
        if (newBusiness.with_website) {
            businessData = {
                ...businessData,
                with_website: (newBusiness.with_website, 10),
            };
        }
        if (!newBusiness.document) {
            delete businessData.document;
        }

        if (!newBusiness.business_image) {
            delete businessData.business_image;
        }

        try {
            const response = await BusinessesforSalecardscreate(businessData);
            addNewBusiness();
            if (response?.data) {
                SuccessSwal("Business created successfully!");
                setShowCreateForm(false);
                if (documentInputRef.current) {
                    documentInputRef.current.value = "";
                }
                if (imageInputRef.current) {
                    imageInputRef.current.value = "";
                }
                    if (imagesInputRef.current) {
                        imagesInputRef.current.value = "";
                    }
                setSelectedCategory("");
                setSearchTerm("");
                setCompanies([]);
                setShowCompanies(false);
                console.log("asdasd");
                setNewBusiness({
                    CIN: "",
                    business_name: "",
                    roc: "",
                    authorised_capital: "",
                    paid_up_capital: "",
                    turn_over: "",
                    pat: "",
                    location: "",
                    vintage_year: "",
                    email: "",
                    date_of_incorporation: "",
                    document: null,
                    business_image: null,
                    about_company: "",
                    industry: "",
                    legal_entity: "",
                    sale_price: "",
                    operation_type: "",
                    with_website: "",
                    Registrant: "",
                    city: "",
                    state: "",
                });
                setBusinessImages([]);
            } else {
                warningSwal("Something went wrong, please try again.");
            }
        } catch (error) {
            console.error("Error creating business:", error);
            const errorMessage =
                error?.response?.data?.message ||
                "An error occurred while creating the business.";
            warningSwal(errorMessage);
        }
    };

    useEffect(() => {
        if (showCreateForm) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showCreateForm]);

    if (!showCreateForm) {
        return null;
    }

    const fileUploadHandler = (event, type) => {
        // Multi-image upload
        if (type === "images") {
            const files = Array.from(event.target.files || []);
            if (files.length === 0) return;

            const validImageTypes = ["image/png", "image/jpg", "image/jpeg"];

            files.forEach((file) => {
                if (!validImageTypes.includes(file.type)) {
                    warningSwal(
                        `Please upload a valid image file (PNG, JPG, JPEG): ${file.name}`
                    );
                    return;
                }

                const fileExtension = file.name.split(".").pop();
                const filename = `${new Date().getTime()}_${file.name.replace(/\s+/g, "_")}`;
                const newFile = new File([file], filename);

                S3FileUpload.uploadFile(newFile, config)
                    .then((data) => {
                        const fullUrl = data.location; // full S3 URL
                        setBusinessImages((prev) => [
                            ...prev,
                            { name: file.name, image: fullUrl },
                        ]);
                    })
                    .catch((err) => {
                        console.error("Error uploading image:", err);
                        warningSwal("Error uploading one of the images. Please try again.");
                    });
            });

            return;
        }

        // Single image or document handling (existing behavior)
        const file = event.target.files?.[0];
        if (!file) return;

        const fileType = file.type;
        const fileExtension = file.name.split(".").pop();
        const filename = `${new Date().getTime()}.${fileExtension}`;
        const newFile = new File([file], filename);

        if (type === "image") {
            const validImageTypes = ["image/png", "image/jpg", "image/jpeg"];
            if (!validImageTypes.includes(fileType)) {
                warningSwal(
                    "Please upload a valid image file (PNG, JPG, JPEG)."
                );
                return;
            }

            S3FileUpload.uploadFile(newFile, config)
                .then((data) => {
                    const modifiedFile = data.location.split("/").pop();
                    setNewBusiness((prev) => ({
                        ...prev,
                        business_image: modifiedFile,
                    }));
                })
                .catch((err) => {
                    console.error("Error uploading image:", err);
                    warningSwal("Error uploading the image. Please try again.");
                });
        } else if (type === "document") {
            const validDocumentTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];

            if (!validDocumentTypes.includes(fileType)) {
                warningSwal("Please upload a valid document (PDF, Word).");
                return;
            }

            S3FileUpload.uploadFile(newFile, config)
                .then((data) => {
                    const modifiedFile = data.location.split("/").pop();
                    setNewBusiness((prev) => ({
                        ...prev,
                        document: modifiedFile,
                        documentType: "document",
                    }));
                })
                .catch((err) => {
                    console.error("Error uploading document:", err);
                    warningSwal(
                        "Error uploading the document. Please try again."
                    );
                });
        }
    };

    const updateImageName = (index, value) => {
        setBusinessImages((prev) => {
            const copy = [...prev];
            copy[index] = { ...copy[index], name: value };
            return copy;
        });
    };

    const removeImage = (index) => {
        setBusinessImages((prev) => prev.filter((_, i) => i !== index));
    };

    const handleCategoryChange = (e) => {
        const category = e.target.value;
        setSelectedCategory(category);
        setSelectedSubcategory("");
        setSelectedItem("");
        handleInputChange(e);
    };

    const handleSubcategoryChange = (e) => {
        const subcategory = e.target.value;
        setSelectedSubcategory(subcategory);
        setSelectedItem("");
        handleInputChange(e);
    };

    const handleItemChange = (e) => {
        const item = e.target.value;
        setSelectedItem(item);
        handleInputChange(e);
    };

    const getSubcategoriesForCategory = (categoryName) => {
        const category = industriesData.find(
            (cat) => cat.category === categoryName
        );
        return category ? category.subcategories : [];
    };

    const getItemsForSubcategory = (subcategoryName) => {
        const category = industriesData.find(
            (cat) => cat.category === selectedCategory
        );
        const subcategory = category?.subcategories.find(
            (sub) => sub.name === subcategoryName
        );
        return subcategory ? subcategory.items : [];
    };

    return (
        <Modal
            isOpen={showCreateForm}
            onRequestClose={() => setShowCreateForm(false)}
            contentLabel="Create Business for Sale"
            className={`${styles.modalContent} ${
                Theme !== "default" ? "green" : ""
            }`}
            overlayClassName={styles.modalOverlay}
            bodyOpenClassName={styles.modalOpen}>
            <div className={styles.createBusinessForm}>
                <div className={styles.createBusinessForm_heading}>
                    <h3>Create a New Business for Sale </h3>
                    <span onClick={() => setShowCreateForm(false)}>
                        <MdCancel style={{ color: "var(--PrimaryColor)" }} />
                    </span>
                </div>

                {/* Company Search Section */}
                <div
                    className={styles.createBusinessForm_input}
                    ref={searchInputRef}>
                    <label htmlFor="company_search">
                        Search Company (by Name or CIN)
                    </label>
                    <div style={{ position: "relative" }}>
                        <input
                            type="text"
                            placeholder="Type at least 2 characters to search companies..."
                            value={companyName}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCompanyName(e.target.value);
                            }}
                            style={{ width: "100%" }}
                        />

                        {loading && (
                            <div
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    fontSize: "12px",
                                    color: "#666",
                                }}>
                                Searching...
                            </div>
                        )}

                        {/* Company Dropdown */}
                        {showCompanies && companies.length > 0 && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    backgroundColor: "white",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    zIndex: 1000,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                }}>
                                {companies.map((company, index) => (
                                    <div
                                        key={index}
                                        onClick={() =>
                                            handleCompanySelect(company)
                                        }
                                        style={{
                                            padding: "10px",
                                            borderBottom:
                                                index < companies.length - 1
                                                    ? "1px solid #eee"
                                                    : "none",
                                            cursor: "pointer",
                                        }}
                                        onMouseEnter={(e) =>
                                            (e.target.style.backgroundColor =
                                                "#f5f5f5")
                                        }
                                        onMouseLeave={(e) =>
                                            (e.target.style.backgroundColor =
                                                "white")
                                        }>
                                        <div
                                            style={{
                                                fontWeight: "bold",
                                                marginBottom: "2px",
                                            }}>
                                            {company.CompanyName}
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "12px",
                                                color: "#666",
                                            }}>
                                            CIN: {company.CIN}
                                        </div>
                                        {company.state && (
                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    color: "#999",
                                                }}>
                                                State: {company.state}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}

                        {error && searchTerm.length >= 2 && (
                            <div
                                style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginTop: "5px",
                                }}>
                                {error}
                            </div>
                        )}
                    </div>
                </div>

                {/* CIN input */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="CIN">CIN</label>
                    <input
                        type="text"
                        name="CIN"
                        placeholder="CIN (will be populated when you select a company)"
                        value={newBusiness.CIN}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                CIN: e.target.value,
                            })
                        }
                        // readOnly
                    />
                </div>

                {/* City & State */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="city">City</label>
                    <input
                        type="text"
                        name="city"
                        placeholder="City"
                        value={newBusiness.city}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                city: e.target.value,
                            })
                        }
                    />

                    <label htmlFor="state">State</label>
                    <input
                        type="text"
                        name="state"
                        placeholder="State"
                        value={newBusiness.state}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                state: e.target.value,
                            })
                        }
                    />
                </div>

                {/* Business Name & Date of Incorporation */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="date_of_incorporation">
                        Date of Incorporation
                    </label>
                    <input
                        type="date"
                        name="date_of_incorporation"
                        placeholder="Date of Incorporation"
                        value={
                            newBusiness.date_of_incorporation
                                ? new Date(newBusiness.date_of_incorporation)
                                      .toISOString()
                                      .split("T")[0]
                                : ""
                        }
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                date_of_incorporation: e.target.value,
                            })
                        }
                    />
                </div>

                {/* Registrar of Companies & Vintage Year */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="roc">Registrar of Companies (ROC)</label>

                    <input
                        type="text"
                        name="roc"
                        placeholder="Registrar of Companies (ROC)"
                        value={newBusiness.roc}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                roc: e.target.value,
                            })
                        }
                    />

                    <label htmlFor="vintage_year">Vintage Year</label>
                    <input
                        type="number"
                        name="vintage_year"
                        placeholder="Vintage Year"
                        value={newBusiness.vintage_year}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                vintage_year: e.target.value,
                            })
                        }
                    />
                </div>

                {/* Sale Price & Email */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="sale_price">Sale Price</label>
                    <input
                        type="number"
                        name="sale_price"
                        placeholder="Sale Price"
                        value={newBusiness.sale_price}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                sale_price: e.target.value,
                            })
                        }
                    />

                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={newBusiness.email}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                email: e.target.value,
                            })
                        }
                        // readOnly
                    />
                </div>

                {/* Capital and Financial Info */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="authorised_capital">
                        Authorised Capital
                    </label>
                    <input
                        type="number"
                        name="authorised_capital"
                        placeholder="Authorised Capital"
                        value={newBusiness.authorised_capital}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                authorised_capital: e.target.value,
                            })
                        }
                        // readOnly
                    />

                    <label htmlFor="paid_up_capital">Paid-up Capital</label>
                    <input
                        type="number"
                        name="paid_up_capital"
                        placeholder="Paid-up Capital"
                        value={newBusiness.paid_up_capital}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                paid_up_capital: e.target.value,
                            })
                        }
                    />
                </div>

                {/* Turnover & PAT */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="turn_over">Turnover</label>
                    <input
                        type="number"
                        name="turn_over"
                        placeholder="Turnover"
                        value={newBusiness.turn_over}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                turn_over: e.target.value,
                            })
                        }
                    />

                    <label htmlFor="pat">PAT</label>
                    <input
                        type="number"
                        name="pat"
                        placeholder="PAT"
                        value={newBusiness.pat}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                pat: e.target.value,
                            })
                        }
                    />
                </div>

                {/* About Company */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="about_company">About the Company</label>
                    <ReactQuill
                        theme="snow"
                        value={newBusiness.about_company}
                        onChange={(content) =>
                            setNewBusiness((prev) => ({
                                ...prev,
                                about_company: content,
                            }))
                        }
                        placeholder="About the Company"
                        style={{ borderRadius: "8px" }}
                    />
                </div>

                {/* Location */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="location">Business Location</label>
                    <input
                        type="text"
                        name="location"
                        placeholder="Business Location"
                        value={newBusiness.location}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                location: e.target.value,
                            })
                        }
                        // readOnly
                    />
                </div>

                {/* Operation Type & Website */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="operation_type">Operation Type</label>
                    <select
                        name="operation_type"
                        value={newBusiness.operation_type}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                operation_type: e.target.value,
                            })
                        }>
                        <option value="">Select Operation Type</option>
                        <option value="Manufacturing">Manufacturing</option>
                        <option value="Services">Services</option>
                        <option value="Retail">Retail</option>
                        <option value="Trading">Trading</option>
                    </select>

                    <label htmlFor="with_website">With Website</label>
                    <select
                        name="with_website"
                        value={newBusiness.with_website}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                with_website: e.target.value,
                            })
                        }>
                        <option value="">Select Website Option</option>
                        <option value="1">With Website</option>
                        <option value="0">Without Website</option>
                    </select>
                </div>

                {/* Website URL */}
                {newBusiness.with_website === "1" && (
                    <div className={styles.createBusinessForm_input}>
                        <label htmlFor="location">Website URL</label>
                        <input
                            type="text"
                            name="location"
                            placeholder="Website URL"
                            value={newBusiness.google}
                            onChange={(e) =>
                                setNewBusiness({
                                    ...newBusiness,
                                    google: e.target.value,
                                })
                            }
                            // readOnly
                        />
                    </div>
                )}

                {/* Business Type */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="Registrant">Registrant</label>
                    <select
                        name="Registrant"
                        value={newBusiness.Registrant}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                Registrant: e.target.value,
                            })
                        }>
                        <option value="">Registrant</option>
                        <option value="0">Business Owner</option>
                        <option value="1">Professional</option>
                        <option value="2">Others</option>
                    </select>
                </div>

                {/* Industry Selection */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="industry">Industry</label>
                    <select
                        name="industry"
                        value={selectedCategory}
                        onChange={handleCategoryChange}>
                        <option value="">Select Category</option>
                        {industriesData.map((category) => (
                            <option
                                key={category.category}
                                value={category.category}>
                                {category.category}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Subcategory & Item Selection */}
                {selectedCategory && (
                    <div className={styles.createBusinessForm_input}>
                        {selectedCategory && (
                            <select
                                value={selectedSubcategory}
                                onChange={handleSubcategoryChange}>
                                <option value="">Select Subcategory</option>
                                {getSubcategoriesForCategory(
                                    selectedCategory
                                ).map((sub) => (
                                    <option key={sub.name} value={sub.name}>
                                        {sub.name}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                )}
                {selectedSubcategory && (
                    <div className={styles.createBusinessForm_input}>
                        {selectedSubcategory && (
                            <select
                                value={selectedItem}
                                onChange={handleItemChange}>
                                <option value="">Select Item</option>
                                {getItemsForSubcategory(
                                    selectedSubcategory
                                ).map((item) => (
                                    <option key={item} value={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                )}
                {/* Legal Entity */}
                <div className={styles.createBusinessForm_input}>
                    <label htmlFor="legal_entity">Legal Entity</label>
                    <select
                        name="legal_entity"
                        value={newBusiness.legal_entity}
                        onChange={(e) =>
                            setNewBusiness({
                                ...newBusiness,
                                legal_entity: e.target.value,
                            })
                        }>
                        <option value="">Select Legal Entity</option>
                        <option value="Sole Proprietorship">
                            Sole Proprietorship
                        </option>
                        <option value="Partnership">Partnership</option>
                        <option value="Limited Liability Partnership">
                            Limited Liability Partnership
                        </option>
                        <option value="Private Limited Company">
                            Private Limited Company
                        </option>
                        <option value="Public Limited Company">
                            Public Limited Company
                        </option>
                        <option value="NBFC Companies">NBFC Companies</option>
                        <option value="Listed Company">Listed Company</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                {/* Business Image Upload */}
                <div className="createBusinessForm_input">
                    <label htmlFor="business_image">
                        Business Image (PNG, JPG, JPEG)(380 * 140)
                    </label>
                    <input
                        type="file"
                        name="business_image"
                        ref={imageInputRef}
                        placeholder="Business Image"
                        accept="image/*"
                        onChange={(e) => fileUploadHandler(e, "image")}
                    />
                    {newBusiness.business_image && (
                        <div>
                            <h4>Image Preview:</h4>
                            <img
                                src={`https://${process.env.REACT_APP_BUCKETNAME}.s3.ap-south-1.amazonaws.com/${newBusiness.business_image}`}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = defaultIMG;
                                }}
                                alt="Business Image Preview"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "cover",
                                }}
                            />
                        </div>
                    )}
                </div>

                {/* Business Images (Multiple) Upload */}
                <div className="createBusinessForm_input">
                    <label htmlFor="business_images">Extra Images (multiple) (PNG, JPG, JPEG)</label>
                    <input
                        type="file"
                        name="business_images"
                        ref={imagesInputRef}
                        placeholder="Business Images"
                        accept="image/*"
                        multiple
                        onChange={(e) => fileUploadHandler(e, "images")}
                    />
                    {businessImages && businessImages.length > 0 && (
                        <div>
                            <h4>Uploaded Images:</h4>
                            {businessImages.map((img, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px",
                                        marginBottom: "8px",
                                    }}>
                                    <img
                                        src={img.image}
                                        onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = defaultIMG;
                                        }}
                                        alt={img.name}
                                        style={{
                                            width: "80px",
                                            height: "60px",
                                            objectFit: "cover",
                                        }}
                                    />
                                    <input
                                        type="text"
                                        value={img.name}
                                        onChange={(e) => updateImageName(idx, e.target.value)}
                                        placeholder="Image name"
                                    />
                                    <button type="button" onClick={() => removeImage(idx)}>
                                        Remove
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Business Document Upload */}
                <div className="createBusinessForm_input">
                    <label htmlFor="document">
                        Business Document (.pdf, .doc, .docx)
                    </label>
                    <input
                        type="file"
                        name="document"
                        ref={documentInputRef}
                        placeholder="Business Document"
                        accept=".pdf, .doc, .docx"
                        onChange={(e) => fileUploadHandler(e, "document")}
                    />
                    {newBusiness.document && (
                        <div>
                            <h4>Document Uploaded:</h4>
                            <a
                                href={`https://${process.env.REACT_APP_BUCKETNAME}.s3.ap-south-1.amazonaws.com/${newBusiness.document}`}
                                target="_blank"
                                rel="noopener noreferrer">
                                {newBusiness.document}
                            </a>
                        </div>
                    )}
                </div>

                {/* Submit Button */}
                <div className={styles.createBusinessForm_button}>
                    <button onClick={handleCreateBusiness}>
                        Create Business
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default CreateBusinessModal;
